import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { Role } from '@interfaces/profiles/role';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private baseUrl: string = environment.apiUrl + 'role';

    private rolesSubject = new BehaviorSubject<Role[]>([]);

    constructor(
        private http: HttpClient
    ) { }

    get roles$(): Observable<Role[]> {
        return this.rolesSubject.asObservable();
    }

    set roles(roles: Role[]) {
        this.rolesSubject.next(roles);
    }

    getList(): Observable<Role[]> {
        return this.http.get<Role[]>(this.baseUrl)
            .pipe(
                map((rolesFromSrv: Role[]) => this.roles = rolesFromSrv)
            );
    }

    getProfileRoles(profileId: number): Observable<Role[]> {
        const params = new HttpParams()
            .append('profileId', `${profileId}`);

        return this.http.get<Role[]>(`${this.baseUrl}/profile`, {params});
    }
}
